import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "../CSS/Default.css";
import Footer from "../components/footer";

const LoginPage = () => {
  const [userName, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleShowPasswordToggle = () => {
    setShowPassword(!showPassword);
  };

  const handleSignUp = () => {
    navigate("/signup");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/login`,
        { userName, password },
        { withCredentials: true } // ✅ Ensures cookies are sent/received
      );

      if (response.status === 200) {
        const user = response.data;
        localStorage.setItem("user", JSON.stringify(user)); // ✅ Stores user object
        console.log("Login successful2:", localStorage.getItem("user"));
        toast.success("Login successful!");
        setTimeout(() => navigate("/"), 100);
        console.log("Login successful2:", localStorage.getItem("user"));
      } else {
        toast.info("Check your Credentials");
      }
    } catch (error) {
      toast.error("Server error");
      console.error("Error:", error);
    }
  };

  return (
    <>
      <div className="bg-gray-50 font-mono text-[#333]">
        <div className="min-h-screen flex flex-col items-center justify-center py-6 px-4">
          <div className="max-w-md w-full border py-8 px-6 rounded-xl shadow-lg border-gray-300 bg-white">
            <h2 className="text-center text-3xl font-extrabold">Login</h2>
            <form className="mt-10 space-y-4" onSubmit={handleSubmit}>
              <div>
                <input
                  type="text"
                  id="username"
                  value={userName}
                  required
                  className="w-full text-sm px-4 py-3 rounded outline-none border-2 focus:border-gray-500"
                  placeholder="User Name"
                  onChange={handleUsernameChange}
                />
              </div>
              <div>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  value={password}
                  required
                  className="w-full text-sm px-4 py-3 rounded outline-none border-2 focus:border-gray-500"
                  placeholder="Password"
                  onChange={handlePasswordChange}
                />
              </div>
              <div className="flex items-center justify-between gap-4">
                <div className="flex items-center">
                  <input
                    className="h-4 w-4 ml-1 shrink-0 text-gray-600 focus:ring-gray-500 border-gray-300 rounded"
                    type="checkbox"
                    id="showPasswordCheckbox"
                    checked={showPassword}
                    onChange={handleShowPasswordToggle}
                  />
                </div>
                <label htmlFor="showPasswordCheckbox" className="mr-60">
                  Show password
                </label>
              </div>

              <button
                type="submit"
                className="w-full py-2.5 px-4 text-sm rounded text-white bg-gray-600 hover:bg-gray-700 focus:outline-none"
              >
                Log In
              </button>

              <button
                type="button"
                onClick={handleSignUp}
                className="w-full mt-2 py-2.5 px-4 text-sm rounded text-white bg-gray-800 hover:bg-gray-900 focus:outline-none"
              >
                Sign Up Instead
              </button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default LoginPage;
